import 'reflect-metadata';
import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite, EntiteStatique } from '.';
import { CentreServiceScolaire, JourneePedagogique } from '.';

@EntiteStatique()
@Entity('calendrier_scolaire')
export class CalendrierScolaire implements BaseEntite {
    static key = 'calendrier-scolaire';

    @PrimaryGeneratedColumn()
    id: number;
    name: string;
    @Column({ nullable: true })
    annnee_scolaire: string;
    @Column({ nullable: true })
    notes: string;

    @Column({ nullable: true })
    fk_centre_service_scolaire: number;
    @ManyToOne(() => CentreServiceScolaire)
    @JoinColumn({ name: 'fk_centre_service_scolaire', referencedColumnName: 'id' })
    centre_service_scolaire?: CentreServiceScolaire;

    @OneToMany(() => JourneePedagogique, (journee: JourneePedagogique) => journee.calendrier, { cascade: true })
    journee: JourneePedagogique[];
}
